module.exports = __webpack_public_path__ + "img/germany.a7a0abee.svg";